module.exports = __webpack_public_path__ + "static/media/scancash.84ea9bd2.png";